import * as React from 'react';
import { useContext } from 'react';
import { Routes, Route, Navigate, RouteObject, useLocation } from 'react-router-dom';

import * as Loadables from './loadables';
import { isLoggedIn, PERMISSIONS } from '@utilities';

import './assets/styles/index.css';
import AuthProvider from '@providers/AuthProvider';
import { AuthenticatedRoute } from '@components/AuthenticatedRoute';
import AppRoutes from '@utilities/app-routes';
import authContext from '@contexts/AuthContext';
import TechnicianBootstrap from '@containers/technician/TechnicianBootstrap';
import { isServiceTeamMember } from '@containers/technician/technicianAccess';

import './assets/styles/colors.css';

export const ROUTES: RouteObject[] = [
	{
		path: AppRoutes.BASE,
		element: <Navigate to={AppRoutes.BASE} replace />
	},
	{
		path: AppRoutes.DASHBOARD,
		element: <Loadables.Dashboard />
	},
	{
		path: AppRoutes.LEADS,
		element: <Loadables.RootLayout />,
		children: [
			{
				path: AppRoutes.LEADS,
				element: (
					<>
						<title>All Leads</title>
						<Loadables.AllLeads />
					</>
				)
			},
			{
				path: AppRoutes.ADD_LEAD,
				element: (
					<>
						<title>Add Leads</title>
						<Loadables.AddLeads />
					</>
				)
			},
			{
				path: AppRoutes.LEAD_DETAILS,
				element: (
					<>
						<title>Lead Details</title>
						<Loadables.LeadDetails />
					</>
				)
			},
			{
				path: AppRoutes.LEAD_QUOTATION,
				element: (
					<>
						<title>Quotations</title>
						<Loadables.LeadQuotation />
					</>
				)
			},
			{
				path: AppRoutes.GENERATE_CURRENT_QUOTATION,
				element: (
					<>
						<title>Generate Quotations</title>
						<Loadables.LeadQuotation />
					</>
				)
			},
			{
				path: AppRoutes.GENERATE_NEW_QUOTATION,
				element: (
					<>
						<title>Generate New Quotations</title>
						<Loadables.LeadQuotation />
					</>
				)
			},
			{
				path: '',
				element: <Navigate to={AppRoutes.LEADS} replace />
			}
		]
	},
	{
		path: AppRoutes.PRODUCTS,
		element: <Loadables.RootLayout />,
		children: [
			{
				path: AppRoutes.ALL_CATEGORIES,
				element: (
					<>
						<title>All Categories</title>
						<Loadables.AllCategories />
					</>
				)
			},
			{
				path: AppRoutes.VARIANTS_GROUPING,
				element: (
					<>
						<title>Variants Grouping</title>
						<Loadables.VariantsGrouping />
					</>
				)
			},
			{
				path: AppRoutes.PARAMETRIC_VARIANTS,
				element: (
					<>
						<title>Parametric Variants</title>
						<Loadables.ParametricVariants />
					</>
				)
			},
			{
				path: AppRoutes.ALL_PRODUCTS,
				element: (
					<>
						<title>All Products</title>
						<Loadables.AllProducts />
					</>
				)
			},
			{
				path: AppRoutes.ADD_PRODUCT,
				element: (
					<>
						<title>Add Product</title>
						<Loadables.AddProduct />
					</>
				)
			},
			{
				path: AppRoutes.UPDATE_PRODUCT,
				element: (
					<>
						<title>Update Product</title>
						<Loadables.UpdateProduct />
					</>
				)
			},
			{
				path: AppRoutes.DEFAULT_MODELS,
				element: (
					<>
						<title>Default 3D Models</title>
						<Loadables.DefaultModels />
					</>
				)
			},
			{
				path: AppRoutes.VIEW_PRODUCT,
				element: (
					<>
						<title>View Product</title>
						<Loadables.ViewProduct />
					</>
				)
			},
			{
				path: AppRoutes.ALL_WARRANTY,
				element: (
					<>
						<title>All Warranty</title>
						<Loadables.AllWarranty />
					</>
				)
			}
		]
	},
	{
		path: AppRoutes.INSPIRATIONS,
		element: <Loadables.RootLayout />,
		children: [
			{
				path: AppRoutes.ALL_INSPIRATIONS,
				element: (
					<>
						<title>All Inspirations</title>
						<Loadables.AllInspirations />
					</>
				)
			},
			{
				path: AppRoutes.ALL_INSPIRATIONS_LEAD_FILTER,
				element: (
					<>
						<title>All Inspirations</title>
						<Loadables.AllInspirations />
					</>
				)
			},
			{
				path: AppRoutes.ALL_INSPIRATIONS_PROJECT_FILTER,
				element: (
					<>
						<title>All Inspirations</title>
						<Loadables.AllInspirations />
					</>
				)
			},
			{
				path: AppRoutes.VIEW_INSPIRATION,
				element: (
					<>
						<title>View Inspiration</title>
						<Loadables.ViewInspiration />
					</>
				)
			},
			{
				path: AppRoutes.ADD_INSPIRATION,
				element: (
					<>
						<title>Add Inspiration</title>
						<Loadables.AddInspiration />
					</>
				)
			},
			{
				path: AppRoutes.LEAD_ADD_INSPIRATION,
				element: (
					<>
						<title>Add Inspiration</title>
						<Loadables.AddInspiration />
					</>
				)
			},
			{
				path: AppRoutes.PROJECT_ADD_INSPIRATION,
				element: (
					<>
						<title>Add Inspiration</title>
						<Loadables.AddInspiration />
					</>
				)
			}
		]
	},
	{
		path: AppRoutes.PROJECTS,
		children: [
			{
				path: AppRoutes.ALL_PROJECTS,
				element: (
					<>
						<title>All Projects</title>
						<Loadables.AllProjects />
					</>
				)
			},
			{
				path: AppRoutes.PROJECT_DETAILS,
				element: (
					<>
						<title>Project Detail</title>
						<Loadables.ProjectDetails />
					</>
				)
			},
			{
				path: AppRoutes.PROJECT_ACTIVITY,
				element: (
					<>
						<title>Project Activity</title>
						<Loadables.ProjectActivity />
					</>
				)
			},
			{
				path: AppRoutes.PROJECT_LEDGER,
				element: (
					<>
						<title>Project Ledger</title>
						<Loadables.ProjectLedger />
					</>
				)
			},
			{
				path: AppRoutes.QUOTATION_ESTIMATE,
				element: (
					<>
						<title>Estimated Quotation</title>
						<Loadables.QuotationEstimate />
					</>
				)
			}
		]
	},
	{
		path: AppRoutes.ORDERS,
		children: [
			{
				path: AppRoutes.ALL_ORDERS,
				element: (
					<>
						<title>All Projects</title>
						<Loadables.AllOrders />
					</>
				)
			},
			{
				path: AppRoutes.ORDER_DETAILS,
				element: (
					<>
						<title>Order Detail</title>
						<Loadables.OrderDetails />
					</>
				)
			}
		]
	},
	{
		path: AppRoutes.COMMERCIALS,
		element: <Loadables.RootLayout />,
		children: [
			{
				path: AppRoutes.COMMERCIALS_PAYMENT,
				element: (
					<>
						<title>Payments</title>
						<Loadables.CommercialsPayment />
					</>
				)
			}
		]
	},
	{
		path: AppRoutes.ALL_TICKETS,
		element: <Loadables.AllTickets />,
		children: [
			{
				path: AppRoutes.TICKET_CHAT,
				element: (
					<>
						<title>Ticket Chat</title>
						<Loadables.TicketChat />
					</>
				)
			}
		]
	},
	{
		path: AppRoutes.PROFILE,
		element: <Loadables.Profile />
	},
	{
		path: AppRoutes.HOLIDAYS,
		element: <Loadables.Holidays />
	},
	{
		path: AppRoutes.APPROVAL,
		element: <Loadables.RootLayout />,
		children: [
			{
				path: AppRoutes.APPROVAL_DELAY,
				element: (
					<>
						<title>Delay Approvals</title>
						<Loadables.DelayApproval />
					</>
				)
			},
			{
				path: AppRoutes.APPROVAL_DOCUMENT,
				element: (
					<>
						<title>Document Approvals</title>
						<Loadables.DocumentApproval />
					</>
				)
			},
			{
				path: AppRoutes.APPROVAL_WARRANTY,
				element: (
					<>
						<title>Warranty Approvals</title>
						<Loadables.WarrantyApproval />
					</>
				)
			},
			{
				path: AppRoutes.APPROVAL_DESCOPE,
				element: (
					<>
						<title>Descope Approvals</title>
						<Loadables.DescopeApproval />
					</>
				)
			},
			{
				path: AppRoutes.APPROVAL_PRODUCT_ITEM,
				element: (
					<>
						<title>Product Approvals</title>
						<Loadables.ProductItemApproval />
					</>
				)
			}
		]
	},
	{
		path: AppRoutes.BUILDER_COSTING,
		element: <Loadables.BuilderCosting />
	},
	{
		path: AppRoutes.PROMO_CODE,
		element: <Loadables.PromoCode />
	},
	{
		path: AppRoutes.INCENTIVES,
		element: <Loadables.Incentives />
	},
	{
		path: AppRoutes.FEEDBACK,
		element: <Loadables.Feedback />
	},
	{
		path: AppRoutes.EMAIL_CONFIG,
		element: <Loadables.EmailConfig />
	}
];

const VariantMakerToBuilderRedirect = () => {
	const location = useLocation();
	return <Navigate to={`${AppRoutes.BUILDER}${location.search}${location.hash}`} replace />;
};

const AppRoutesView = () => {
	const location = useLocation();
	const loggedIn = isLoggedIn();
	const { user, hasPermission } = useContext(authContext) as any;
	const departmentBasedElectrician =
		typeof user?.department === 'string' && user.department.toUpperCase() === 'ADMIN';
	const permissionBasedElectrician =
		typeof hasPermission === 'function' ? hasPermission(PERMISSIONS.ELECTRICAL_EDIT) : undefined;
	const isElectrician = loggedIn
		? permissionBasedElectrician !== undefined
			? permissionBasedElectrician
			: departmentBasedElectrician
		: false;
	const isTechnician = loggedIn && !isElectrician && isServiceTeamMember(user);

	if (loggedIn && isElectrician) {
		return (
			<Routes>
				<Route path={AppRoutes.BASE} element={<Navigate to={AppRoutes.ELECTRICAL_BASE} />} />
				<Route path={AppRoutes.ELECTRICAL_BASE} element={<Loadables.ElectricalDashboard />} />
				<Route path={AppRoutes.ELECTRICAL_PROJECT_DETAILS} element={<Loadables.ElectricalProjectDetails />} />
				<Route path={AppRoutes.ELECTRICAL_SITE_PHOTOS} element={<Loadables.ElectricalSitePhotos />} />
				<Route path={AppRoutes.ELECTRICAL_PRODUCT_DETAILS} element={<Loadables.ElectricalProductDetails />} />
				<Route path="*" element={<Navigate to={AppRoutes.ELECTRICAL_BASE} />} />
			</Routes>
		);
	}

	if (loggedIn && isTechnician) {
		return (
			<TechnicianBootstrap>
				<Routes>
					<Route path={AppRoutes.BASE} element={<Navigate to={AppRoutes.TECHNICIAN_BASE} />} />
					<Route path={AppRoutes.TECHNICIAN_BASE} element={<Loadables.TechnicianDashboard />} />
					<Route path="*" element={<Navigate to={AppRoutes.TECHNICIAN_BASE} />} />
				</Routes>
			</TechnicianBootstrap>
		);
	}

	return (
		<Routes>
			<Route path={AppRoutes.BASE} element={<Navigate to={AppRoutes.DASHBOARD} />} />

			<Route
				path={AppRoutes.BUILDER}
				element={
					<AuthenticatedRoute>
						<title>Variant Builder</title>
						<Loadables.VariantBuilder />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.VARIANT_MAKER}
				element={<VariantMakerToBuilderRedirect />}
			/>

			<Route
				path={AppRoutes.CUSTOMER_GENERATE_QUOTATION}
				element={
					<>
						<title>Generate Quotation</title>
						<Loadables.GenerateQuotation />
					</>
				}
			/>
			<Route
				path={AppRoutes.NEW_PROJECT}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.PROJECT_EDIT}>
						<title>New Project</title>
						<Loadables.NewProject key="new-project" />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.RESUME_QUOTATION}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.PROJECT_EDIT}>
						<title>Resume Quotation</title>
						<Loadables.NewProject key={location.pathname} />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.TIMELINE}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.PROJECT_EDIT}>
						<title>Timeline</title>
						<Loadables.Timeline />
					</AuthenticatedRoute>
				}
			/>
			{!isLoggedIn() ? <Route path={AppRoutes.LOGIN} element={<Loadables.Login />} /> : null}
			<Route
				path={AppRoutes.LEADS}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.LEAD_READ}>
						<title>Leads</title>
						<Loadables.AllLeads />
					</AuthenticatedRoute>
				}
			/>
			<Route path={AppRoutes.PRODUCTS}>
				<Route
					path={AppRoutes.ALL_CATEGORIES}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.CATEGORIES_READ}>
							<title>All Categories</title>
							<Loadables.AllCategories />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.VARIANTS_GROUPING}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.CATEGORIES_READ}>
							<title>Variants Grouping</title>
							<Loadables.VariantsGrouping />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.PARAMETRIC_VARIANTS}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.CATEGORIES_READ}>
							<title>Parametric Variants</title>
							<Loadables.ParametricVariants />
						</AuthenticatedRoute>
					}
				/>

				<Route
					path={AppRoutes.ALL_PRODUCTS}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.PRODUCT_READ}>
							<title>All Products</title>
							<Loadables.AllProducts />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.ADD_PRODUCT}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.PRODUCT_EDIT}>
							<title>Add Product</title>
							<Loadables.AddProduct />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.UPDATE_PRODUCT}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.PRODUCT_EDIT}>
							<title>Update Product</title>
							<Loadables.UpdateProduct />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.DEFAULT_MODELS}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.ADMIN}>
							<title>Default 3D Models</title>
							<Loadables.DefaultModels />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.VIEW_PRODUCT}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.PRODUCT_READ}>
							<title>View Product</title>
							<Loadables.ViewProduct />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.ALL_WARRANTY}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.WARRANTY_READ}>
							<title>All Warranty</title>
							<Loadables.AllWarranty />
						</AuthenticatedRoute>
					}
				/>
			</Route>
			<Route path={AppRoutes.INSPIRATIONS}>
				<Route
					path={AppRoutes.ALL_INSPIRATIONS}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.INSPIRATION_READ}>
							<title>All Inspirations</title>
							<Loadables.AllInspirations />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.ALL_INSPIRATIONS_LEAD_FILTER}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.INSPIRATION_READ}>
							<title>All Inspirations</title>
							<Loadables.AllInspirations />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.ALL_INSPIRATIONS_PROJECT_FILTER}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.INSPIRATION_READ}>
							<title>All Inspirations</title>
							<Loadables.AllInspirations />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.VIEW_INSPIRATION}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.INSPIRATION_READ}>
							<title>View Inspiration</title>
							<Loadables.ViewInspiration />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.ADD_INSPIRATION}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.INSPIRATION_EDIT}>
							<title>Add Inspiration</title>
							<Loadables.AddInspiration />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.LEAD_ADD_INSPIRATION}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.INSPIRATION_EDIT}>
							<title>Add Inspiration</title>
							<Loadables.AddInspiration />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.PROJECT_ADD_INSPIRATION}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.INSPIRATION_EDIT}>
							<title>Add Inspiration</title>
							<Loadables.AddInspiration />
						</AuthenticatedRoute>
					}
				/>
			</Route>

			<Route
				path={AppRoutes.ADD_LEAD}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.LEAD_EDIT}>
						<title>Add Leads</title>
						<Loadables.AddLeads />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.LEAD_QUOTATION}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.PROJECT_READ}>
						<title>Quotation</title>
						<Loadables.LeadQuotation />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.GENERATE_CURRENT_QUOTATION}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.PROJECT_EDIT}>
						<title>Generate Quotation</title>
						<Loadables.LeadQuotation />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.GENERATE_NEW_QUOTATION}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.PROJECT_EDIT}>
						<title>Generate New Quotation</title>
						<Loadables.LeadQuotation />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.LEAD_DETAILS}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.LEAD_READ}>
						<title>Lead Details</title>
						<Loadables.LeadDetails />
					</AuthenticatedRoute>
				}
			/>
			<Route path={AppRoutes.ORDERS}>
				<Route
					path={AppRoutes.ALL_ORDERS}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.PROJECT_READ}>
							<title>All Orders</title>
							<Loadables.AllOrders />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.ORDER_DETAILS}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.PROJECT_READ}>
							<title>Order Details</title>
							<Loadables.OrderDetails />
						</AuthenticatedRoute>
					}
				/>
			</Route>
			<Route path={AppRoutes.PROJECTS}>
				<Route
					path={AppRoutes.ALL_PROJECTS}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.PROJECT_READ}>
							<title>All Projects</title>
							<Loadables.AllProjects />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.ADD_PROJECT}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.PROJECT_EDIT}>
							<title>Add Project</title>
							<Loadables.AddProjects />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.PROJECT_ACTIVITY}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.PROJECT_READ}>
							<title>Project Activity</title>
							<Loadables.ProjectActivity />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.PROJECT_DETAILS}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.PROJECT_READ}>
							<title>Project Details</title>
							<Loadables.ProjectDetails />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={`${AppRoutes.PROJECTS}/:projectID/promo-code`}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.PROMO_CODE_EDIT}>
							<title>Apply Promo Code</title>
							<Loadables.ProjectPromoApply />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.PROJECT_LEDGER}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.PROJECT_READ}>
							<title>Project Ledger</title>
							<Loadables.ProjectLedger />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.QUOTATION_ESTIMATE}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.PROJECT_READ}>
							<title>Quotation Estimate</title>
							<Loadables.QuotationEstimate />
						</AuthenticatedRoute>
					}
				/>
			</Route>
			<Route path={AppRoutes.COMMERCIALS}>
				<Route
					path={AppRoutes.COMMERCIALS_PAYMENT}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.COMMERCIAL_READ}>
							<title>Payments</title>
							<Loadables.CommercialsPayment />
						</AuthenticatedRoute>
					}
				/>
			</Route>
			<Route
				path={AppRoutes.HOLIDAYS}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.CALENDAR_READ}>
						<title>Holidays</title>
						<Loadables.Holidays />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.ORGANIZATION}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.USER_READ}>
						<title>Organization</title>
						<Loadables.Organization />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.ORGANIZATION_SCHEDULER_MAPPING}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.ADMIN}>
						<title>Scheduler Stage Mapping</title>
						<Loadables.SchedulerStageMapping />
					</AuthenticatedRoute>
				}
			/>
			<Route path={AppRoutes.APPROVAL}>
				<Route
					path={AppRoutes.APPROVAL_DELAY}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.APPROVAL_READ}>
							<title>Delay Approvals</title>
							<Loadables.DelayApproval />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.APPROVAL_DOCUMENT}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.APPROVAL_READ}>
							<title>Document Approvals</title>
							<Loadables.DocumentApproval />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.APPROVAL_WARRANTY}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.APPROVAL_READ}>
							<title>Warranty Approvals</title>
							<Loadables.WarrantyApproval />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.APPROVAL_DESCOPE}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.APPROVAL_READ}>
							<title>Descope Approvals</title>
							<Loadables.DescopeApproval />
						</AuthenticatedRoute>
					}
				/>
				<Route
					path={AppRoutes.APPROVAL_PRODUCT_ITEM}
					element={
						<AuthenticatedRoute permission={PERMISSIONS.APPROVAL_READ}>
							<title>Product Approvals</title>
							<Loadables.ProductItemApproval />
						</AuthenticatedRoute>
					}
				/>
			</Route>
			<Route
				path={AppRoutes.PROFILE}
				element={
					<AuthenticatedRoute>
						<title>Profile</title>
						<Loadables.Profile />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.ALL_TICKETS}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.TICKET_READ}>
						<title>Tickets</title>
						<Loadables.AllTickets />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.DASHBOARD}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.DASHBOARD_READ}>
						<title>Dashboard</title>
						<Loadables.Dashboard />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.TICKET_CHAT}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.TICKET_READ}>
						<title>Tickets Chat</title>
						<Loadables.TicketChat />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.BUILDER_COSTING}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.COSTING_READ}>
						<title>Builder Costing</title>
						<Loadables.BuilderCosting />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.PROMO_CODE}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.PROMO_CODE_READ}>
						<title>Promo Code</title>
						<Loadables.PromoCode />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.INCENTIVES}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.ADMIN}>
						<title>Incentives</title>
						<Loadables.Incentives />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.FEEDBACK}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.ADMIN}>
						<title>Feedback</title>
						<Loadables.Feedback />
					</AuthenticatedRoute>
				}
			/>
			<Route
				path={AppRoutes.EMAIL_CONFIG}
				element={
					<AuthenticatedRoute permission={PERMISSIONS.ADMIN}>
						<title>Email Config</title>
						<Loadables.EmailConfig />
					</AuthenticatedRoute>
				}
			/>
			{
				<Route
					path={AppRoutes.LOGIN}
					element={loggedIn ? <Navigate to={AppRoutes.BASE} /> : <Loadables.Login />}
				/>
			}
			<Route path="*" element={<Navigate to={AppRoutes.BASE} />} />
		</Routes>
	);
};

export const App = () => {
	return (
		<>
			<AuthProvider>
				<AppRoutesView />
			</AuthProvider>
		</>
	);
};
